import { ReactElement } from 'react'
import { useFormContext } from 'react-hook-form'
import { SaveButton } from '@ui/actions'

interface Props {
  loading: boolean
  fullWidth?: boolean
  'data-cy'?: string
  disableIfNotDirty?: boolean
  text?: string
  disabled?: boolean
  form?: string
}

const SubmitButton = ({
  loading,
  fullWidth = true,
  'data-cy': dataCy,
  disableIfNotDirty = true,
  text,
  disabled = false,
  form,
}: Props): ReactElement => {
  const {
    formState: { isDirty },
  } = useFormContext()

  return (
    <SaveButton
      loading={loading}
      disabled={(disableIfNotDirty && !isDirty) || disabled}
      size="small"
      fullWidth={fullWidth}
      type="submit"
      data-cy={dataCy}
      form={form}
    >
      {text ?? 'Speichern'}
    </SaveButton>
  )
}

export default SubmitButton
